<template>
  <div class="app-container">
    <div class="filter-container">
      <div class="big-top">
        <el-radio-group
          class="filter-item"
          size="mini"
          style="margin-right: 16px"
          @change="dateTypeChange"
          v-model="listQuery.dateType"
        >
          <el-radio-button :label="1">按日</el-radio-button>
          <el-radio-button :label="2">按周</el-radio-button>
          <el-radio-button :label="3">按月</el-radio-button>
          <el-radio-button :label="4">按年</el-radio-button>
          <el-radio-button :label="5">自定义</el-radio-button>
        </el-radio-group>
        <el-date-picker
          :picker-options="datePickerOption"
          class="filter-item"
          size="mini"
          v-show="listQuery.dateType == 1"
          :clearable="false"
          v-model="listQuery.searchDate"
          type="date"
          format="yyyy年MM月dd日"
          placeholder="选择日"
        >
        </el-date-picker>
        <el-date-picker
          :picker-options="datePickerOption"
          class="filter-item"
          size="mini"
          v-show="listQuery.dateType == 2"
          :clearable="false"
          v-model="listQuery.searchDate"
          type="week"
          format="yyyy年WW周"
          placeholder="选择周"
        >
        </el-date-picker>
        <el-date-picker
          :picker-options="datePickerOption"
          class="filter-item"
          size="mini"
          v-show="listQuery.dateType == 3"
          :clearable="false"
          v-model="listQuery.searchDate"
          type="month"
          format="yyyy年MM月"
          placeholder="选择月"
        >
        </el-date-picker>
        <el-date-picker
          :picker-options="datePickerOption"
          class="filter-item"
          size="mini"
          v-show="listQuery.dateType == 4"
          :clearable="false"
          v-model="listQuery.searchDate"
          type="year"
          format="yyyy年"
          placeholder="选择年"
        >
        </el-date-picker>
        <el-date-picker
          :picker-options="datePickerOption"
          class="filter-item"
          size="mini"
          v-show="listQuery.dateType == 5"
          :clearable="false"
          v-model="listQuery.searchDate"
          type="daterange"
          format="yyyy年MM月dd日"
          start-placeholder="选择开始日期"
          end-placeholder="选择结束日期"
        >
        </el-date-picker>
        <el-select
          class="filter-item width_320"
          v-model="listQuery.sources"
          multiple
          placeholder="选择渠道"
        >
          <el-option
            v-for="item in sourceList"
            :key="item.dataName"
            :label="item.dataDisplay"
            :value="item.dataName"
          ></el-option>
        </el-select>
        <el-cascader
          clearable
          class="filter-item width_350"
          placeholder="选择经销商"
          filterable
          :props="{ checkStrictly: true }"
          :show-all-levels="false"
          :options="dealerOptions"
          v-model="listQuery.dealerCode"
        ></el-cascader>
        <el-button
          class="filter-item"
          size="mini"
          type="info"
          icon="el-icon-search"
          @click="handleSearch"
          style="margin-left: 16px"
        >
          查看
        </el-button>
        <el-button
          class="filter-item"
          size="mini"
          icon="el-icon-refresh"
          style="margin-left: 16px !important"
          @click="doReset"
        >
          重置
        </el-button>
        <el-button
          class="filter-item"
          size="mini"
          icon="el-icon-refresh"
          style="margin-left: 16px !important"
          @click="doExport"
        >
          导出
        </el-button>
      </div>
    </div>
    <div class="pure-g">
      <div class="pure-u-1">
        <div class="pure-g">
          <div class="pure-u-1-5">
            <div class="whiteBox dashboard_number">
              <div class="title">
                线索跟进（清洗）率
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="正常下发且完成清洗的线索数/正常下发的线索数（包含线下）"
                  placement="top"
                >
                  <i class="el-icon-question" style="margin-left: 6px"></i>
                </el-tooltip>
              </div>
              <div class="number">{{ stastisticsData.followRatio === '-' ? 0 : stastisticsData.followRatio || 0 }}%</div>
            </div>
          </div>
          <div class="pure-u-1-5">
            <div class="whiteBox dashboard_number">
              <div class="title">
                有效线索到店率
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="有效线索到店数/有效线索数（包含线下）"
                  placement="top"
                >
                  <i class="el-icon-question" style="margin-left: 6px"></i>
                </el-tooltip>
              </div>
              <div class="number">{{ stastisticsData.arriveRatio === '-' ? 0 : stastisticsData.arriveRatio || 0 }}%</div>
            </div>
          </div>
          <div class="pure-u-1-5">
            <div class="whiteBox dashboard_number">
              <div class="title">
                到店成交率
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="交车的订单数/到店的客户数"
                  placement="top"
                >
                  <i class="el-icon-question" style="margin-left: 6px"></i>
                </el-tooltip>
              </div>
              <div class="number">{{ stastisticsData.dealRatio === '-' ? 0 : stastisticsData.dealRatio || 0 }}%</div>
            </div>
          </div>
          <div class="pure-u-1-5">
            <div class="whiteBox dashboard_number">
              <div class="title">
                线索有效率
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="有效线索数/正常下发的线索数（包含线下）"
                  placement="top"
                >
                  <i class="el-icon-question" style="margin-left: 6px"></i>
                </el-tooltip>
              </div>
              <div class="number">
                {{ stastisticsData.clueValidRatio === '-' ? 0 : stastisticsData.clueValidRatio || 0 }}%
              </div>
            </div>
          </div>
          <div class="pure-u-1-5">
            <div class="whiteBox dashboard_number">
              <div class="title">
                线索成交率
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="成交的线索数/正常下发的线索数（包含线下）"
                  placement="top"
                >
                  <i class="el-icon-question" style="margin-left: 6px"></i>
                </el-tooltip>
              </div>
              <div class="number">
                {{ stastisticsData.clueDealRatio === '-' ? 0 : stastisticsData.clueDealRatio || 0 }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "StatisticsIndex",
  data() {
    return {
      listQuery: {
        dateType: 1,
        searchDate: new Date(),
      },
      datePickerOption: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime(new Date()) > Date.now() || time.getTime(new Date()) < new Date('1969-12-31').getTime();
        },
      },
      importSources: [],
      offlineSources: [],
      dealerOptions: [],
      stastisticsData: {},
    };
  },
  computed: {
    sourceList() {
      return this.importSources.concat(this.offlineSources);
    },
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  activated() {},
  created() {
    this.retrieveSystemData();
    this.getOfflineSources();
    this.retrieveDealerOptions();
    this.assessIndicator(this.getSearchParams());
  },
  methods: {
    // 获取数据
    assessIndicator(params) {
      const loading = this.$loading({
        lock: true,
        text: "正在查询...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$httpAuth
        .post("/v1/backendReportRpc/assessIndicator", params)
        .then((response) => {
          this.stastisticsData = response.data;
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    retrieveSystemData() {
      this.$httpAuth
        .post("/v1/backendDictionaryRpc/getDictionaries", {
          category: "BYD_IMPORT_SOURCE",
        })
        .then((response) => {
          this.importSources = response.data.data;
        })
        .catch(() => {});
    },
    getOfflineSources() {
      this.$httpAuth
        .post("/v1/backendDictionaryRpc/getDictionaries", {
          category: "BYD_OFFLINE_SOURCE",
        })
        .then((response) => {
          this.offlineSources = response.data.data;
        })
        .catch(() => {});
    },
    retrieveDealerOptions() {
      this.$httpAuth
        .post("/v1/backendDealerRpc/jsonTree", {})
        .then((response) => {
          this.dealerOptions = response.data.data;
          this.dealerOptions.unshift({
            label: "全部",
            level: 1,
            value: "",
          });
        })
        .catch(() => {});
    },
    dateTypeChange(val) {
      this.listQuery.searchDate = new Date();
    },
    // 重置
    doReset() {
      this.listQuery = {
        dateType: 1,
        searchDate: new Date(),
      };
      this.assessIndicator(this.getSearchParams());
    },
    // 搜索
    handleSearch() {
      this.assessIndicator(this.getSearchParams());
    },
    // 聚合搜索参数
    getSearchParams() {
      let startDate = "";
      let endDate = "";
      if (this.listQuery.dateType == 1) {
        // 日
        startDate = this.listQuery.searchDate.Format("yyyy-MM-dd");
        endDate = this.listQuery.searchDate.Format("yyyy-MM-dd");
      }
      if (this.listQuery.dateType == 2) {
        // 周
        startDate = this.formatDay().getFirstDayOfWeek(
          this.listQuery.searchDate
        );
        endDate = this.formatDay().getEndDayOfWeek(this.listQuery.searchDate);
      }
      if (this.listQuery.dateType == 3) {
        // 月
        startDate = this.formatDay().getFirstDayOfMonth(
          this.listQuery.searchDate
        );
        endDate = this.formatDay().getEndDayOfMonth(this.listQuery.searchDate);
      }
      if (this.listQuery.dateType == 4) {
        // 年
        // const nowDate = this.listQuery.searchDate.Format("yyyy-MM-dd");
        // const currentYear = dayjs().year();
        // const targetYear = dayjs(nowDate).year();
        // if (targetYear === currentYear) {
        //   // 在今年
        //   startDate = this.formatDay().getFirstDayOfYear(
        //     this.listQuery.searchDate
        //   );
        //   endDate = new Date().Format("yyyy-MM-dd");
        // } else {
          // 不在今年
          startDate = this.formatDay().getFirstDayOfYear(
            this.listQuery.searchDate
          );
          endDate = this.formatDay().getEndDayOfYear(this.listQuery.searchDate);
        // }
      }
      if (this.listQuery.dateType == 5 && this.listQuery.searchDate.length) {
        // 自定义
        startDate = this.listQuery.searchDate[0].Format("yyyy-MM-dd");
        endDate = this.listQuery.searchDate[1].Format("yyyy-MM-dd");
      }
     
      var datestart = null
      var dateend = null
      if (startDate) {
        // 定义日期字符串
        const dateString = `${startDate} 00:00:00`;
        // 使用 day.js 解析日期字符串
        const date = dayjs(dateString, 'YYYY-MM-DD HH:mm:ss');
        // 获取秒级时间戳
         datestart = date.unix();
      }
      if (endDate) {
        // 定义日期字符串
        const dateString = `${endDate} 23:59:59`;
        // 使用 day.js 解析日期字符串
        const date = dayjs(dateString, 'YYYY-MM-DD HH:mm:ss');
        // 获取秒级时间戳
        dateend = date.unix();
      }
      let obj = {
        datestart,
        dateend,
        fetchDetailFlag: true,
      };
      if (this.listQuery.sources) {
        obj.sources = this.listQuery.sources;
      }
      if (this.listQuery.dealerCode) {
        const [
          dealerSalesCenter,
          dealerBigArea,
          dealerProvince,
          dealerCity,
          dealerCode,
        ] = this.listQuery.dealerCode;
        obj = {
          ...obj,
          dealerSalesCenter,
          dealerBigArea,
          dealerProvince,
          dealerCity,
          dealerCode,
        };
      }
      return obj;
    },
    // 时间处理函数
    formatDay() {
      const comjs = {};
      comjs.getFirstDayOfWeek = function (date) {
        var weekday = date.getDay() || 7; //获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7
        date.setDate(date.getDate() - weekday + 1); //往前算（weekday-1）天，年份、月份会自动变化
        return date.Format("yyyy-MM-dd");
      };
      comjs.getEndDayOfWeek = function (date) {
        var weekday = date.getDay() || 7; //获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7
        date.setDate(date.getDate() - weekday + 1 + 6); //往前算（weekday-1）天，年份、月份会自动变化
        return date.Format("yyyy-MM-dd");
      };
      comjs.getFirstDayOfMonth = function (date) {
        date.setDate(1);
        return date.Format("yyyy-MM-dd");
      };
      comjs.getEndDayOfMonth = function (date) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        if (month == 0) {
          month = 12;
          year = year - 1;
        }
        if (month < 10) {
          month = "0" + month;
        }
        var myDate = new Date(year, month, 0);
        return year + "-" + month + "-" + myDate.getDate();
      };
      comjs.getFirstDayOfYear = function (date) {
        date.setDate(1);
        date.setMonth(0);
        return date.Format("yyyy-MM-dd");
      };
      comjs.getEndDayOfYear = function (date) {
        var year = date.getFullYear();
        return year + "-12-31";
      };
      return comjs;
    },
    // 导出
    doExport() {
      const loading = this.$loading({
        lock: true,
        text: "正在导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const that = this;
      this.$httpAuth
        .post(
          "/v1/backendReportRpc/assessIndicatorExport",
          that.getSearchParams()
        )
        .then((response) => {
          setTimeout(() => {
            loading.close();
            var a = document.createElement("a");
            a.href = response.data.file;
            a.click();
          }, 1000);
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped>
.filter-item {
  margin-bottom: 0 !important;
}
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}

.whiteBox {
  background-color: #ffffff;
  box-shadow: rgb(206, 211, 217) 1px 1px 1px 1px;
  padding: 30px;
}

.dashboard_number {
  margin-right: 20px;
  padding: 20px 20px 5px 20px;
  height: 130px;
}

.dashboard_number .title {
  font-size: 14px;
  line-height: 30x;
  height: 30px;
  border-bottom-width: 0px;
  padding-bottom: 5px;
  font-weight: 400;
  color: #606266;
}

.dashboard_number .number {
  font-size: 30px;
  border-bottom-width: 0px;
  line-height: 30px;
  height: 40px;
  color: #303133;
}
.big-top {
  width: 100%;
  background: #ffffff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.width_320{
  width: 320px;
}
</style>
